import { LabelGenerator } from '../../types';

export const isCustomLabel: LabelGenerator = (_, productCardsProduct) =>
  productCardsProduct?.use_custom_label
    ? { icon: 'TopOffer', label: productCardsProduct.custom_label_text || '' }
    : false;
